import React, { FC } from 'react'
import { IconProps, SIZES, SVG } from '../../exports'

/* Styles ======================================================================================== */
import { CostReportDetailedStyled } from './cost-report-detailed.styled'

const CostReportDetailed: FC<IconProps> = props => {
  const { size = 'xxl', isAnimated, color, ...others } = props
  const theme = {
    color: `${color ? color : 'currentColor'}`,
  }
  return (
    <CostReportDetailedStyled
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={isAnimated !== undefined ? 'is-animated' : ''}
      theme={theme.color}
      {...SIZES[size]}
      {...others}
    >
      <path
        d="M42 5L43 5"
        className="stroke-bg stroke-bg-1 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 9L45 9"
        className="stroke-bg stroke-bg-2 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 34H3"
        className="stroke-bg stroke-bg-3 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 41H7"
        className="stroke-bg stroke-bg-4 secondary-stroke-color"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8C10 7.44772 10.4477 7 11 7H34C34.5523 7 35 7.44772 35 8V38C35 38.5523 34.5523 39 34 39H11C10.4477 39 10 38.5523 10 38V8Z"
        className="fill-bg primary-fill-color"
      />
      <path
        d="M32.3736 11H14V31.5714M32.3736 11L39 18.4667M32.3736 11V18.4667H39M39 18.4667V21.2857M14 38.4286V43H39V28.1429"
        className="stroke stroke-path"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0125 29.2095C31.0125 30.3015 30.6975 31.1765 30.0675 31.8345C29.4375 32.4925 28.6745 32.9265 27.7785 33.1365V34.4805C27.7785 34.9705 27.7295 35.3135 27.6315 35.5095C27.5475 35.7055 27.4145 35.8385 27.2325 35.9085C27.0645 35.9785 26.8335 36.0135 26.5395 36.0135C26.2455 36.0135 26.0075 35.9785 25.8255 35.9085C25.6575 35.8385 25.5385 35.7125 25.4685 35.5305C25.3705 35.2925 25.3215 34.9355 25.3215 34.4595V33.1575C24.7475 33.0315 24.2295 32.8215 23.7675 32.5275C23.3055 32.2335 22.9835 31.9745 22.8015 31.7505L22.5285 31.3935C22.2345 31.0155 22.0875 30.6865 22.0875 30.4065C22.0875 30.1265 22.3255 29.7555 22.8015 29.2935C23.0815 29.0275 23.3755 28.8945 23.6835 28.8945C24.0055 28.8945 24.4465 29.1745 25.0065 29.7345C25.4405 30.2665 25.9305 30.5325 26.4765 30.5325C27.5125 30.5325 28.0305 30.1055 28.0305 29.2515C28.0305 28.9435 27.8345 28.7055 27.4425 28.5375C27.0505 28.3695 26.5745 28.2225 26.0145 28.0965C25.4545 27.9565 24.8945 27.7745 24.3345 27.5505C23.7745 27.3265 23.2985 26.9415 22.9065 26.3955C22.5145 25.8495 22.3185 25.1565 22.3185 24.3165C22.3185 23.4765 22.5845 22.7205 23.1165 22.0485C23.6485 21.3765 24.3835 20.9425 25.3215 20.7465V19.5705C25.3215 19.0945 25.3635 18.7515 25.4475 18.5415C25.5875 18.2055 25.9585 18.0375 26.5605 18.0375C26.9385 18.0375 27.2185 18.1215 27.4005 18.2895C27.5965 18.4435 27.7085 18.6115 27.7365 18.7935C27.7645 18.9755 27.7785 19.2415 27.7785 19.5915V20.7675C28.1705 20.8515 28.5275 20.9705 28.8495 21.1245C29.1715 21.2785 29.3955 21.4045 29.5215 21.5025L29.7105 21.6705L29.7945 21.7335C30.1445 22.0555 30.3195 22.3215 30.3195 22.5315C30.3195 22.7415 30.1515 23.0915 29.8155 23.5815C29.4935 24.0715 29.1365 24.3165 28.7445 24.3165C28.4925 24.3165 28.2755 24.2535 28.0935 24.1275C27.9255 24.0015 27.7925 23.8965 27.6945 23.8125C27.5965 23.7285 27.5055 23.6585 27.4215 23.6025C27.1835 23.4485 26.8825 23.3715 26.5185 23.3715C26.1545 23.3715 25.8535 23.4625 25.6155 23.6445C25.3775 23.8125 25.2585 24.0505 25.2585 24.3585C25.2585 24.6665 25.3985 24.9185 25.6785 25.1145C25.9725 25.2965 26.3295 25.4225 26.7495 25.4925C27.1695 25.5485 27.6315 25.6535 28.1355 25.8075C28.6395 25.9475 29.1015 26.1155 29.5215 26.3115C29.9415 26.5075 30.2915 26.8575 30.5715 27.3615C30.8655 27.8515 31.0125 28.4675 31.0125 29.2095Z"
        className="fill stroke-path"
      />
    </CostReportDetailedStyled>
  )
}

export default CostReportDetailed
